<template>
    <div class="content detail">
        <div class="detailheader">
            <div class="detailtitle" v-html="boardData.wr_subject"></div>
            <p class="detail_p">{{returnDate(boardData.created_at)}}</p>
        </div>
        <div class="detailbody">
            <div v-html="boardData.wr_content"></div>
<!--            <div class="dbody_photo"  :style="`background-image:url(${returnImage(boardData)})`"></div>-->
        </div>
        <button class="detail_btn" @click="backEvent()">목록</button>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import imageOption from "@/mixins/imageOption";
    export default {
        name: "BoardDetailBusinessLayout",
        mixins: [imageOption],
        components: {},
        props: {
            boardData: {
                type: Object,
                default: () => {return {}},
            },
        },
        data() {
            return {}
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            backEvent(){
                this.$router.go(-1);
            },
            returnImage(data) {
                if (this.hasFile(data)) {
                    return `${data.File.File[0].org_url}?${this.setImageOptions(579, 413, 'jpg')}`
                }
                else { return ''}
            },
            hasFile(data) {
                return !util.isEmpty(data.File) && data.File.hasOwnProperty('File') && !util.isEmpty(data.File.File)
            },
            returnDate(date = null) {
                if (!date) {
                    return '';
                }
                return this.$moment(date).format('YYYY-MM-DD HH:mm')
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>